export const DEFAULT_TRACES_ASSETS = ['BTC', 'BTC', 'BTC', 'BTC'];
export const DEFAULT_TRACES_CODES = [
  'addresses.ActiveCount',
  'addresses.NewNonZeroCount',
  'indicators.Sopr',
  'market.PriceUsdClose',
];
export const DEFAULT_TRACES_COLORS = ['#e44aa0', '#7ed321', '#6d5ced', '#2b2b2b'];
export const DEFAULT_TRACES_NUMBER = 2;

export const MAX_TRACES_NUMBER = 4;
export const MAIN_AXIS_IDX = 0;
